(() => {
  const tiers = [[1000000, 'FALL10'], [3000000, 'FALL15'], [6000000, 'FALL20'], [10000000, 'FALL25']];
  const campaignCodes = new Set(tiers.map((tier) => tier[1]));
  const root = window.Shopify?.routes?.root || '/';
  let pending = Promise.resolve();

  const codesForCart = (cart) => {
    if (cart.currency !== 'JPY') return null;
    const subtotal = window.NelpandaTierDiscountSubtotal(cart.items);
    const tier = tiers.filter(([minimum]) => subtotal >= minimum).pop();
    const codes = cart.discount_codes.map(({ code }) => code).filter((code) => !campaignCodes.has(code.toUpperCase()));
    if (tier) codes.push(tier[1]);
    return codes;
  };

  const requestCart = async (options) => {
    const response = await fetch(root + (options ? 'cart/update.js' : 'cart.js'), {
      cache: 'no-store', ...options
    });
    if (!response.ok) throw new Error('Unable to update cart discount');
    return response.json();
  };

  const sync = () => {
    pending = pending.catch(() => {}).then(async () => {
      const cart = await requestCart();
      const codes = codesForCart(cart);
      if (!codes || codes.map((code) => code.toUpperCase()).sort().join(',') === cart.discount_codes.map(({ code }) => code.toUpperCase()).sort().join(',')) return cart;
      return requestCart({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      });
    });
    return pending;
  };

  window.NelpandaTierDiscountCodes = { codesForCart, sync };

  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('[data-tier-checkout]');
    if (!form) return;
    const button = form.querySelector('[name="checkout"]');
    const error = document.createElement('p');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    button.before(error);
    let submitting = false;
    let readyToSubmit = false;

    const refreshSummary = async (cart) => {
      if (Number(form.dataset.cartTotal) === cart.total_price) return;
      const response = await fetch(location.href, { cache: 'no-store' });
      if (!response.ok) throw new Error('Unable to refresh cart totals');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      for (const selector of ['#order-summary-container .cart-summary-table', '.order-summary-toggle__total-recap']) {
        const current = document.querySelector(selector);
        const updated = page.querySelector(selector);
        if (!current || !updated) throw new Error('Cart totals missing');
        current.replaceWith(updated);
      }
      form.dataset.cartTotal = String(cart.total_price);
    };

    const showError = () => {
      error.textContent = form.dataset.discountError;
      error.hidden = false;
      button.classList.remove('btn--loading');
    };

    sync().then(refreshSummary).catch(showError);
    document.addEventListener('submit', async (event) => {
      if (event.target !== form || event.defaultPrevented || event.submitter?.name !== 'checkout') return;
      if (readyToSubmit) {
        readyToSubmit = false;
        return;
      }
      event.preventDefault();
      if (submitting) return;
      submitting = true;
      button.disabled = true;
      error.hidden = true;
      try {
        await refreshSummary(await sync());
        button.disabled = false;
        readyToSubmit = true;
        form.requestSubmit(event.submitter);
      } catch (_) {
        showError();
      } finally {
        readyToSubmit = false;
        submitting = false;
        button.disabled = false;
      }
    });
  });
})();
